<div class="landing-page" *transloco="let t; read: 'landing'">
  <!-- Header Fixo -->
  <header class="landing-header">
    <div class="header-content">
      <div class="logo">FLOWTIFY</div>
      <div class="header-buttons">
        <app-language-switcher></app-language-switcher>
        <button (click)="scrollToPlans()" class="header-plans-button">
          {{ t('header.viewPlans') }}
        </button>
        <a routerLink="/login" class="header-login-button">
          {{ t('header.access') }}
        </a>
      </div>
    </div>
  </header>

  <!-- Hero Section -->
  <section class="hero-section">
    <div class="hero-content">
      <h1 class="hero-title">FLOWTIFY</h1>
      <p class="hero-subtitle">{{ t('hero.subtitle') }}</p>
      <p class="hero-description">
        {{ t('hero.description') }}
      </p>
      <button (click)="scrollToFeatures()" class="scroll-down-button">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
        </svg>
      </button>
    </div>
    <div class="hero-background"></div>
  </section>

  <!-- Features Section -->
  <section class="features-section">
    <div class="container">
      <h2 class="section-title">{{ t('features.title') }}</h2>
      <p class="section-subtitle">{{ t('features.subtitle') }}</p>

      <div class="features-grid">
        <!-- Feature 1: Dashboard -->
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-chart-line"></i>
          </div>
          <h3 class="feature-title">{{ t('features.dashboardTitle') }}</h3>
          <p class="feature-description">
            {{ t('features.dashboardDesc') }}
          </p>
        </div>

        <!-- Feature 2: Impressão de Etiquetas com Bip -->
        <div class="feature-card feature-card-highlight">
          <div class="feature-icon">
            <i class="fas fa-qrcode"></i>
          </div>
          <h3 class="feature-title">{{ t('features.bipTitle') }}</h3>
          <p class="feature-description">
            <strong>{{ t('features.bipHighlight') }}</strong> {{ t('features.bipDesc') }}
          </p>
        </div>

        <!-- Feature 3: Scanner QR Code -->
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-qrcode"></i>
          </div>
          <h3 class="feature-title">{{ t('features.scannerTitle') }}</h3>
          <p class="feature-description">
            {{ t('features.scannerDesc') }}
          </p>
        </div>

        <!-- Feature 4: Faturas de Cobrança -->
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-file-invoice"></i>
          </div>
          <h3 class="feature-title">{{ t('features.invoicesTitle') }}</h3>
          <p class="feature-description">
            {{ t('features.invoicesDesc') }}
          </p>
        </div>

        <!-- Feature 5: Integração Mercado Livre -->
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-shopping-cart"></i>
          </div>
          <h3 class="feature-title">{{ t('features.mlTitle') }}</h3>
          <p class="feature-description">
            {{ t('features.mlDesc') }}
          </p>
        </div>

      </div>
    </div>
  </section>

  <!-- Roadmap Section -->
  <section class="roadmap-section">
    <div class="container">
      <h2 class="section-title">{{ t('roadmap.title') }}</h2>
      <p class="section-subtitle">{{ t('roadmap.subtitle') }}</p>

      <div class="roadmap-grid">
        <div class="roadmap-item">
          <div class="roadmap-icon">
            <i class="fas fa-warehouse"></i>
          </div>
          <h3 class="roadmap-title">{{ t('roadmap.stockTitle') }}</h3>
          <p class="roadmap-description">
            {{ t('roadmap.stockDesc') }}
          </p>
        </div>

        <div class="roadmap-item">
          <div class="roadmap-icon">
            <i class="fas fa-industry"></i>
          </div>
          <h3 class="roadmap-title">{{ t('roadmap.productionTitle') }}</h3>
          <p class="roadmap-description">
            {{ t('roadmap.productionDesc') }}
          </p>
        </div>

        <div class="roadmap-item">
          <div class="roadmap-icon">
            <i class="fas fa-calculator"></i>
          </div>
          <h3 class="roadmap-title">{{ t('roadmap.priceTitle') }}</h3>
          <p class="roadmap-description">
            {{ t('roadmap.priceDesc') }}
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- Plans Section -->
  <section class="plans-section" id="plans">
    <div class="container">
      <h2 class="section-title">{{ t('plans.title') }}</h2>
      <p class="section-subtitle">{{ t('plans.subtitle') }}</p>

      <div class="plans-grid">
        <!-- Starter Plan -->
        <div class="plan-card">
          <div class="plan-header">
            <h3 class="plan-name">Starter</h3>
            <div class="plan-price">
              <span class="plan-currency">R$</span>
              <span class="plan-amount">19</span>
              <span class="plan-period">{{ t('plans.perMonth') }}</span>
            </div>
          </div>
          <ul class="plan-features">
            <li class="plan-feature-with-children">
              <div class="plan-feature-main">
                <i class="fas fa-check"></i> {{ t('plans.labelPrinting') }}
              </div>
              <ul class="plan-subfeatures">
                <li><i class="fas fa-check"></i> {{ t('plans.perMonthCount', { count: 300 }) }}</li>
              </ul>
            </li>
            <li class="plan-feature-with-children">
              <div class="plan-feature-main">
                <i class="fas fa-check"></i> {{ t('plans.dashboard') }}
              </div>
              <ul class="plan-subfeatures">
                <li><i class="fas fa-check"></i> {{ t('plans.cancelledMetrics') }}</li>
                <li><i class="fas fa-check"></i> {{ t('plans.topSales') }}</li>
                <li><i class="fas fa-check"></i> {{ t('plans.weeklyComparison') }}</li>
              </ul>
            </li>
            <li class="plan-feature-disabled"><i class="fas fa-check"></i> {{ t('plans.production') }}</li>
            <li class="plan-feature-with-children plan-feature-disabled">
              <div class="plan-feature-main">
                <i class="fas fa-check"></i> {{ t('plans.mlChat') }}
              </div>
              <ul class="plan-subfeatures">
                <li><i class="fas fa-check"></i> {{ t('plans.aiIntegrated') }}</li>
              </ul>
            </li>
            <li class="plan-feature-disabled"><i class="fas fa-check"></i> {{ t('plans.stockControl') }}</li>
            <li class="plan-feature-disabled"><i class="fas fa-check"></i> {{ t('plans.priceCalculator') }}</li>
          </ul>
          <a routerLink="/login" class="plan-button">{{ t('plans.subscribe') }}</a>
        </div>

        <!-- Essential Plan -->
        <div class="plan-card plan-card-featured">
          <div class="plan-badge">{{ t('plans.popular') }}</div>
          <div class="plan-header">
            <h3 class="plan-name">Essential</h3>
            <div class="plan-price">
              <span class="plan-currency">R$</span>
              <span class="plan-amount">49</span>
              <span class="plan-period">{{ t('plans.perMonth') }}</span>
            </div>
          </div>
          <ul class="plan-features">
            <li class="plan-feature-with-children">
              <div class="plan-feature-main">
                <i class="fas fa-check"></i> {{ t('plans.labelPrinting') }}
              </div>
              <ul class="plan-subfeatures">
                <li><i class="fas fa-check"></i> {{ t('plans.perMonthCount', { count: 1000 }) }}</li>
              </ul>
            </li>
            <li class="plan-feature-with-children">
              <div class="plan-feature-main">
                <i class="fas fa-check"></i> {{ t('plans.dashboard') }}
              </div>
              <ul class="plan-subfeatures">
                <li><i class="fas fa-check"></i> {{ t('plans.cancelledMetrics') }}</li>
                <li><i class="fas fa-check"></i> {{ t('plans.topSales') }}</li>
                <li><i class="fas fa-check"></i> {{ t('plans.weeklyComparison') }}</li>
              </ul>
            </li>
            <li><i class="fas fa-check"></i> {{ t('plans.production') }}</li>
            <li class="plan-feature-with-children plan-feature-disabled">
              <div class="plan-feature-main">
                <i class="fas fa-check"></i> {{ t('plans.mlChat') }}
              </div>
              <ul class="plan-subfeatures">
                <li><i class="fas fa-check"></i> {{ t('plans.aiIntegrated') }}</li>
              </ul>
            </li>
            <li class="plan-feature-disabled"><i class="fas fa-check"></i> {{ t('plans.stockControl') }}</li>
            <li class="plan-feature-disabled"><i class="fas fa-check"></i> {{ t('plans.priceCalculator') }}</li>
          </ul>
          <a routerLink="/login" class="plan-button plan-button-featured">{{ t('plans.subscribe') }}</a>
        </div>

        <!-- Professional Plan -->
        <div class="plan-card">
          <div class="plan-header">
            <h3 class="plan-name">Professional</h3>
            <div class="plan-price">
              <span class="plan-currency">R$</span>
              <span class="plan-amount">99</span>
              <span class="plan-period">{{ t('plans.perMonth') }}</span>
            </div>
          </div>
          <ul class="plan-features">
            <li class="plan-feature-with-children">
              <div class="plan-feature-main">
                <i class="fas fa-check"></i> {{ t('plans.labelPrinting') }}
              </div>
              <ul class="plan-subfeatures">
                <li><i class="fas fa-check"></i> {{ t('plans.perMonthCount', { count: 3000 }) }}</li>
              </ul>
            </li>
            <li class="plan-feature-with-children">
              <div class="plan-feature-main">
                <i class="fas fa-check"></i> {{ t('plans.dashboard') }}
              </div>
              <ul class="plan-subfeatures">
                <li><i class="fas fa-check"></i> {{ t('plans.cancelledMetrics') }}</li>
                <li><i class="fas fa-check"></i> {{ t('plans.topSales') }}</li>
                <li><i class="fas fa-check"></i> {{ t('plans.weeklyComparison') }}</li>
              </ul>
            </li>
            <li><i class="fas fa-check"></i> {{ t('plans.production') }}</li>
            <li class="plan-feature-with-children plan-feature-disabled">
              <div class="plan-feature-main">
                <i class="fas fa-check"></i> {{ t('plans.mlChat') }}
              </div>
              <ul class="plan-subfeatures">
                <li><i class="fas fa-check"></i> {{ t('plans.aiIntegrated') }}</li>
              </ul>
            </li>
            <li><i class="fas fa-check"></i> {{ t('plans.stockControl') }}</li>
            <li class="plan-feature-disabled"><i class="fas fa-check"></i> {{ t('plans.priceCalculator') }}</li>
          </ul>
          <a routerLink="/login" class="plan-button">{{ t('plans.subscribe') }}</a>
        </div>

        <!-- Elite Plan -->
        <div class="plan-card plan-card-premium">
          <div class="plan-badge plan-badge-premium">{{ t('plans.premium') }}</div>
          <div class="plan-header">
            <h3 class="plan-name">Elite</h3>
            <div class="plan-price">
              <span class="plan-currency">R$</span>
              <span class="plan-amount">169</span>
              <span class="plan-period">{{ t('plans.perMonth') }}</span>
            </div>
          </div>
          <ul class="plan-features">
            <li class="plan-feature-with-children">
              <div class="plan-feature-main">
                <i class="fas fa-check"></i> {{ t('plans.labelPrinting') }}
              </div>
              <ul class="plan-subfeatures">
                <li><i class="fas fa-check"></i> <strong>{{ t('plans.unlimited') }}</strong></li>
              </ul>
            </li>
            <li class="plan-feature-with-children">
              <div class="plan-feature-main">
                <i class="fas fa-check"></i> {{ t('plans.dashboard') }}
              </div>
              <ul class="plan-subfeatures">
                <li><i class="fas fa-check"></i> {{ t('plans.cancelledMetrics') }}</li>
                <li><i class="fas fa-check"></i> {{ t('plans.topSales') }}</li>
                <li><i class="fas fa-check"></i> {{ t('plans.weeklyComparison') }}</li>
              </ul>
            </li>
            <li><i class="fas fa-check"></i> {{ t('plans.production') }}</li>
            <li class="plan-feature-with-children">
              <div class="plan-feature-main">
                <i class="fas fa-check"></i> {{ t('plans.mlChat') }}
              </div>
              <ul class="plan-subfeatures">
                <li><i class="fas fa-check"></i> {{ t('plans.aiIntegrated') }}</li>
              </ul>
            </li>
            <li><i class="fas fa-check"></i> {{ t('plans.stockControl') }}</li>
            <li><i class="fas fa-check"></i> {{ t('plans.priceCalculator') }}</li>
          </ul>
          <a routerLink="/login" class="plan-button plan-button-premium">{{ t('plans.subscribe') }}</a>
        </div>
      </div>
    </div>
  </section>

  <!-- Benefits Section -->
  <section class="benefits-section">
    <div class="container">
      <h2 class="section-title">{{ t('benefits.title') }}</h2>

      <div class="benefits-grid">
        <div class="benefit-item">
          <div class="benefit-icon">
            <i class="fas fa-clock"></i>
          </div>
          <h3 class="benefit-title">{{ t('benefits.timeTitle') }}</h3>
          <p class="benefit-description">
            {{ t('benefits.timeDesc') }}
          </p>
        </div>

        <div class="benefit-item">
          <div class="benefit-icon">
            <i class="fas fa-shield-alt"></i>
          </div>
          <h3 class="benefit-title">{{ t('benefits.securityTitle') }}</h3>
          <p class="benefit-description">
            {{ t('benefits.securityDesc') }}
          </p>
        </div>

        <div class="benefit-item">
          <div class="benefit-icon">
            <i class="fas fa-mobile-alt"></i>
          </div>
          <h3 class="benefit-title">{{ t('benefits.multiplatformTitle') }}</h3>
          <p class="benefit-description">
            {{ t('benefits.multiplatformDesc') }}
          </p>
        </div>

        <div class="benefit-item">
          <div class="benefit-icon">
            <i class="fas fa-chart-bar"></i>
          </div>
          <h3 class="benefit-title">{{ t('benefits.insightsTitle') }}</h3>
          <p class="benefit-description">
            {{ t('benefits.insightsDesc') }}
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA Final Section -->
  <section class="cta-section">
    <div class="container">
      <div class="cta-content">
        <h2 class="cta-title">{{ t('cta.title') }}</h2>
        <p class="cta-description">
          {{ t('cta.description') }}
        </p>
        <a routerLink="/login" class="cta-button-large">
          <span>{{ t('cta.access') }}</span>
          <svg class="w-6 h-6 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
          </svg>
        </a>
      </div>
    </div>
  </section>
</div>
